import TagIcon from "@atlaskit/icon/core/tag";
import {AnankeTempCollapsibleSectionWithIcon} from "~/components/anankeTemp/anankeTempCollapsibleSectionWithIcon";
import type {OttopilotEventTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventTemplate";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import {ItemBuilder} from "@vesta/global-common-typescript/components/itemBuilder";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function LinkedJourneyEventsOverviewSection({
    title,
    eventTemplates,
    linkedJourneyEventTemplateIds,
    initialIsOpen,
    className,
}: {
    title: string;
    eventTemplates: Array<OttopilotEventTemplate>;
    linkedJourneyEventTemplateIds: Array<Uuid>;
    initialIsOpen?: boolean;
    className?: string;
}) {
    const counts = new Map<Uuid, number>();
    for (const templateId of linkedJourneyEventTemplateIds) {
        counts.set(templateId, (counts.get(templateId) ?? 0) + 1);
    }

    const eventTypeCounts = eventTemplates.map((template) => ({
        template: template,
        count: counts.get(template.id) ?? 0,
    }));

    const eventRows: Array<Array<{template: OttopilotEventTemplate; count: number}>> = [];
    for (let index = 0; index < eventTypeCounts.length; index += 2) {
        eventRows.push(eventTypeCounts.slice(index, index + 2));
    }

    return (
        <AnankeTempCollapsibleSectionWithIcon
            title={title}
            icon={TagIcon}
            iconColor="var(--ds-icon-accent-blue)"
            iconBackgroundColor="var(--ds-background-accent-blue-subtlest)"
            initialIsOpen={initialIsOpen ?? true}
            className={className}
        >
            <div className="grid grid-flow-row gap-y-ds-space-150">
                <ItemBuilder
                    items={eventRows}
                    itemBuilder={(row) => (
                        <div
                            key={row.map((item) => item.template.id).join("-")}
                            className="grid grid-cols-2 gap-ds-space-150"
                        >
                            <ItemBuilder
                                items={row}
                                itemBuilder={(item) => (
                                    <div
                                        key={item.template.id}
                                        className="bg-ds-background-disabled flex gap-ds-space-075 items-center px-ds-space-150 py-ds-space-100 rounded-ds-border-radius"
                                    >
                                        <div className="flex-1 min-w-0">
                                            <span className="truncate">
                                                <AnankeText size="medium">
                                                    {item.template.displayName}
                                                </AnankeText>
                                            </span>
                                        </div>
                                        <div className="bg-ds-background-neutral-subtle flex items-center px-ds-space-050 rounded-ds-border-radius-small">
                                            <span className="font-bold uppercase">
                                                <AnankeText size="small">
                                                    {item.count.toString()}
                                                </AnankeText>
                                            </span>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    )}
                />
            </div>
        </AnankeTempCollapsibleSectionWithIcon>
    );
}
